import type { ReactNode } from "react";

import { cn } from "../lib/utils";

type PageContainerProps = {
  /** Reading measure. `6xl` matches most apps; the hub runs wider. */
  maxWidth?: "6xl" | "7xl";
  className?: string;
  children: ReactNode;
};

const MAX_WIDTHS = {
  "6xl": "max-w-6xl",
  "7xl": "max-w-7xl",
} as const;

/**
 * The reading-width column with page gutters that chrome'd pages sit in.
 *
 * A root layout that leaves `main` full-bleed - so a wide report or table can
 * use the whole window - has each page supply its own gutters with this.
 */
export function PageContainer({
  maxWidth = "6xl",
  className,
  children,
}: PageContainerProps) {
  return (
    <div
      className={cn(
        "mx-auto w-full px-4 py-6 pb-10 sm:px-6 sm:py-8 sm:pb-12 lg:px-8",
        MAX_WIDTHS[maxWidth],
        className,
      )}
    >
      {children}
    </div>
  );
}
